import { convertFromNext, convertToNext } from '../check/arbitrary/definition/Converters.js';
import { set } from './set.js';
import { tuple } from './tuple.js';
import { keyValuePairsToObjectMapper, keyValuePairsToObjectUnmapper } from './_internals/mappers/KeyValuePairsToObject.js';
export function dictionary(keyArb, valueArb) {
    return convertFromNext(convertToNext(set(tuple(keyArb, valueArb), { compare: (t1, t2) => t1[0] === t2[0] })).map(keyValuePairsToObjectMapper, keyValuePairsToObjectUnmapper));
}
